( function( $, moment ) {
    "use strict";

    var _events = {
        onChangeDateSameDay: function() {
            var $checkbox = $(this),
                targetId = $checkbox.attr('id').substr(0, $checkbox.attr('id').length - 9),
                $target = $('#' + targetId);

            $target.closest('[gr-grid]').toggleClass('hidden', $checkbox.prop('checked'));

            if ($checkbox.prop('checked') && $target.val() !== '') {
                $target.val('').trigger('change');
            }
        }
    };

    var $body = $('body');

    $body.on('app.ready', function (ev) {
       $body.on('change', '#roadmap_form_arrival_date_same_day', _events.onChangeDateSameDay)
       $body.on('change', '#roadmap_form_openning_date_same_day', _events.onChangeDateSameDay)
    });

}( require('jquery') ));
